import api from '@/services/Api';

class PdfService {
  async getRepairPackageWaitingPdf(repairFileBoomerangId) {
    const response = await api.get('/distributor/get-client-package-waiting-pdf/' + repairFileBoomerangId, {
      responseType: 'blob'
    })
    return response.data
  }

  async getRepairPackagePdf(repairFileBoomerangId) {
    const response = await api.get('/distributor/get-client-package-pdf/' + repairFileBoomerangId, {
      responseType: 'blob'
    })
    return response.data
  }

  async getRepairOrderWaitingTransportPdf(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/get-repair-order-waiting-transport-pdf/' + repairFileBoomerangId,
      {
      responseType: 'blob'
    })
    return response.data
  }

  async getRepairOrderWithTransportPdf(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/get-repair-order-with-transport-pdf/' + repairFileBoomerangId,
      {
      responseType: 'blob'
    })
    return response.data
  }

  async getRepairOrderWithoutTransportPdf(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/get-repair-order-without-transport-pdf/' + repairFileBoomerangId,
      {
      responseType: 'blob'
    })
    return response.data
  }

  async getFileAttachmentForRepairer(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/get-repairer-file-pdf/' + repairFileBoomerangId,
      {
      responseType: 'blob'
    })
    return response.data
  }

  async getGuaranteeExtensionBoomerangPdf(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/get-guarantee-extension-boomerang-pdf/' + repairFileBoomerangId,
      {
        responseType: 'blob'
      })
    return response.data
  }
}

export default new PdfService()
